import { Controller } from "@hotwired/stimulus"

// ⌘↩ / Ctrl+↩ shares the post, so a finished thought need not reach for the
// mouse. Nothing is submitted while the field is empty.
export default class extends Controller {
  static targets = ["field"]

  keydown(event) {
    if (event.key === "Enter" && (event.metaKey || event.ctrlKey) && this.words() > 0) {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }

  words() {
    const text = this.hasFieldTarget ? this.fieldTarget.value : ""
    return text.trim() ? text.trim().split(/\s+/).length : 0
  }
}
